module.exports = __webpack_public_path__ + "img/normal_multiplier.6c69b47b.png";